import styled from 'styled-components';
import breakPoints from 'theme/Media';

export const GrowEnvironmentModalStyled = styled.div.attrs({
  className: 'GrowEnvironmentModal',
})``;
